/* ZdamPrawko – drobne zachowania motywu (menu mobilne, cień nagłówka). */
(function () {
  var header = document.querySelector('[data-zdp-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var menu = document.querySelector('[data-zdp-menu]');
  if (menu) {
    // zamknij menu po kliknięciu linku, klawiszu Esc lub kliknięciu poza nim
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) menu.removeAttribute('open'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu.removeAttribute('open'); });
    document.addEventListener('click', function (e) { if (!menu.contains(e.target)) menu.removeAttribute('open'); });
  }
})();
